import { SupplierOrderItemList } from '../components/PurchaseOrders/PurchaseOrderDrawer'

export const calculateSupplierTotals = (
  items: SupplierOrderItemList,
  settings: { taxRate: number; taxInclusive: boolean }
) => {
  const subtotal = (() => {
    const itemsTotal = items.reduce(
      (sum, item) =>
        item.type === 'lineItem' && item.selected
          ? sum + item.costPrice * item.quantity
          : sum,
      0
    )

    const materialsTotal = items.reduce(
      (sum, item) =>
        item.type === 'material' && item.selected
          ? sum + item.costPerUnit * item.quantity
          : sum,
      0
    )

    return itemsTotal + materialsTotal
  })()

  const tax = settings.taxInclusive
    ? subtotal * (settings.taxRate / (100 + settings.taxRate))
    : subtotal * (settings.taxRate / 100)

  const total = settings.taxInclusive ? subtotal : subtotal + tax

  return { subtotal, tax, total }
}
